var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-white shadow-md hover:shadow-xl rounded-xl transition-all delay-100 duration-75 max-h-20",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "h-16 bg-gray-100 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2",
        },
        [_vm._t("header")],
        2
      ),
      _c("div", { staticClass: "grid grid-cols-5" }, [
        _c("div", { staticClass: "col-span-2" }, [
          _c("div", { staticClass: "max-h-20 -mt-20" }, [_vm._t("default")], 2),
          _c(
            "div",
            { staticClass: "grid ml-3 mb-1/12" },
            [_vm._t("GroupModalWithButton")],
            2
          ),
        ]),
        _c(
          "div",
          { staticClass: "col-span-3 px-6 pb-6 mt-12" },
          [_vm._t("groupMessage")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }